import * as React from "react";

const ChevronLeftLarge: React.FC = () => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M9.5 12L15.4797 18.0065C16.0035 18.5326 15.9442 19.3997 15.3536 19.8496C14.8647 20.2221 14.1758 20.1758 13.7411 19.7411L6 12L13.7411 4.25885C14.1758 3.82424 14.8647 3.7779 15.3536 4.15039C15.9442 4.60033 16.0035 5.46736 15.4797 5.9935L9.5 12Z" fill="currentColor"/>
        </svg> 
    );
};

export default React.memo(ChevronLeftLarge);
